import { createContext, useContext } from 'react';

/**
 * Closes the Post sheet from inside its body (`usePostSheetClose`, the sheet's own latch): a
 * signed-out answer closes the sheet before the sign-in drawer opens, one drawer at a time
 * (TECH-197 § Where a poll opens, OPTION 1 · 1c). Null outside a sheet.
 */
export const PostSheetCloseContext = createContext<(() => void) | null>(null);

export function usePostSheetCloseFromBody(): (() => void) | null {
  return useContext(PostSheetCloseContext);
}
